function toFilenamePart(value: string | null | undefined): string {
  return (value ?? '').trim().replace(/[^a-zA-Z0-9]+/g, '_').replace(/^_+|_+$/g, '');
}

/** e.g. Modelo + C4 -> Modelo_C4.zip */
export function buildReportImagesZipFilename(
  campaignName: string | null | undefined,
  cycleName: string | null | undefined,
): string {
  const campaign = toFilenamePart(campaignName);
  const cycle = toFilenamePart(cycleName);
  if (!campaign) {
    throw new Error('Campaign name is required to name the images download.');
  }
  return cycle ? `${campaign}_${cycle}.zip` : `${campaign}.zip`;
}

/** Strip characters that are unsafe inside ZIP entry paths. */
export function sanitizeReportImageEntryName(value: string | null | undefined): string {
  return (value ?? '').replace(/[/\\?%*:|"<>]/g, '-').trim();
}

/** Guarantee a ZIP entry stays in the archive root (no folder segments). */
export function ensureFlatZipEntryFilename(filename: string): string {
  const leafName = filename.split(/[/\\]/).pop() ?? filename;
  return leafName.replace(/[/\\?%*:|"<>]/g, '-').trim();
}

/** e.g. Magnum Aisle Ends + Mallow-450 -> Magnum Aisle Ends_Mallow-450 */
export function buildReportImageEntryBasename(
  campaignName: string | null | undefined,
  storeName: string | null | undefined,
  evidenceAssetId?: number,
): string {
  const campaign = sanitizeReportImageEntryName(campaignName) || 'Campaign';
  const store = sanitizeReportImageEntryName(storeName)
    || (evidenceAssetId ? `image-${evidenceAssetId}` : 'Store');
  return `${campaign}_${store}`;
}

export function dedupeReportImageFilename(
  usedNames: Map<string, number>,
  baseName: string,
): string {
  const count = usedNames.get(baseName) ?? 0;
  usedNames.set(baseName, count + 1);
  return count === 0 ? `${baseName}.jpg` : `${baseName} (${count + 1}).jpg`;
}
